module.exports = require('./helpers/bundle-url').getBundleURL('ex1cr') + "../images/info.3c8efd64.svg";